import React from 'react'

const SvgAddProfessionalOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.877 8.103A5 5 0 1013 11.9v-1.01c.018-.48.075-.732.24-1.158a3 3 0 111.483-1.474A3.121 3.121 0 0115.89 8h.22c.265 0 .523.036.767.103z'
    />
    <path d='M15 10.89a.89.89 0 01.89-.89h.22a.89.89 0 01.89.89V15h4.11a.89.89 0 01.89.89v.22a.89.89 0 01-.89.89H17v4.11a.89.89 0 01-.89.89h-.22a.89.89 0 01-.89-.89V17h-4.11a.89.89 0 01-.89-.89v-.22a.89.89 0 01.89-.89H15v-4.11z' />
    <path d='M8 15.877c0-.708.254-1.355.676-1.858L7.376 14l-.074.004-.072.053c-.616.456-.951.704-.951 1.487v.685c1.15.226 1.425 1.337 1.425 2.067v1.577c0 .34-.279.614-.623.614a.618.618 0 01-.622-.614c0-.279.188-.514.446-.589v-.988c0-.666-.478-1.205-1.068-1.205-.59 0-1.067.54-1.067 1.205v.988c.257.075.445.31.445.589 0 .34-.279.614-.622.614a.618.618 0 01-.623-.614v-1.578c0-.729.275-1.84 1.425-2.066v-.685c0-.507.132-.92.524-1.35C3.306 14.8 2 16.732 2 19.988c0 1.333.657 2 1.97 2h9.17c-.091-.28-.14-.58-.14-.89v-2.11h-2.11A2.89 2.89 0 018 16.097v-.22z' />
  </svg>
)

export default SvgAddProfessionalOutline
